<template>
  <div class="comment">
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item>
        <el-input
          class="input"
          clearable
          v-model="keyword"
          @input="currentChange(1)"
          placeholder="搜索关键字"
          prefix-icon="el-icon-search">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-select
          class="select"
          v-model="status"
          @change="currentChange(1)"
          placeholder="请选择"
          clearable>
          <el-option
            label="全部"
            value="">
          </el-option>
          <el-option
            label="已显示"
            :value="1">
          </el-option>
          <el-option
            label="未显示"
            :value="0">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="refresh" icon="el-icon-refresh">刷新</el-button>
      </el-form-item>
    </el-form>
    <div class="list">
      <div class="item" v-for="(item,index) in comments" :key="index">
        <div class="user">
          <div class="head-img">
            <template v-if="item.user"><img class="head-img" :src="item.user.headimg"></template>
            <template v-else><img class="head-img" :src="$store.state.default_img_url"></template>
          </div>
          <div class="text">
            <div class="name gray">
              <template v-if="item.user"><span>{{item.user.name}}</span></template>
              <template v-else><span>未知</span></template>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span>
                {{item.created_at}}
                <i class="small">({{getDay(item.created_at)}})</i>
              </span>
            </div>
            <div class="comment">
              <pre>{{item.text}}</pre>
            </div>
            <div class="images" v-if="item.images&&item.images.length>0">
              <div class="images-item" v-for="img in item.images" :key="img">
                <img :src="img" v-img-auto v-img-frame>
              </div>
            </div>
            <div class="tenant-reply" v-if="item.official_reply">
              <h4>回复</h4>
              <p v-html="changeline(item.official_reply)"></p>
            </div>
            <div class="bottom gray" v-if="item.movie">
              <span>《{{item.movie.title}}》</span>
            </div>
          </div>
          <div class="operation">
            <el-switch
              @change="changeHandle($event,item)"
              class="switch"
              v-model="item.status"
              active-color="#13ce66"
              inactive-color="#999999"
              :active-value="1"
              :inactive-value="0"
              size="small">
            </el-switch>
            <i class="el-icon-delete delete cursor-pointer gray" @click="deleteComment(item)"></i>
            <i class="iconfont reply cursor-pointer gray" @click="ShowReplyCommentLayer(item)">&#xe609;</i>
          </div>
        </div>
      </div>
      <div class="empty" v-if="noData">
        <img src="/static/images/no-comment.png">
      </div>
    </div>
    <el-pagination
      v-if="comments.length>0"
      class="page"
      background
      layout="total, sizes, prev, pager, next"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="per_page"
      :total="total"
      :current-page="page"
      @current-change="currentChange"
      @size-change="handleSizeChange">
    </el-pagination>
    <mask-layer v-model="isShowReplyCommentLayer">
      <div class="reply-content">
        <h3>回复评论</h3>
        <el-input
          type="textarea"
          :rows="4"
          v-model="replyText"
          clearable
          placeholder="请输入内容,500字以内">
        </el-input>
        <div class="btn-group">
          <el-button type="primary" @click="replyComment" :disabled="replyText===''">确定</el-button>
          <el-button @click="isShowReplyCommentLayer=false">取消</el-button>
        </div>
      </div>
    </mask-layer>
  </div>
</template>
<script>
import MaskLayer from '@/components/MaskLayer'
import request from '@/utils/request'
import getDay from '@/utils/getDay'
export default {
  name: 'musicComment',
  components: {
    MaskLayer
  },
  data () {
    return {
      page: 1,
      total: 0,
      per_page: 5,
      keyword: '',
      comments: [],
      status: '',
      isShowReplyCommentLayer: false,
      currentReply: '',
      replyText: '',
      noData: false
    }
  },
  created () {
    this.getComments()
  },
  methods: {
    getComments () {
      return new Promise((resolve, reject) => {
        let sendData = {
          page: this.page,
          per_page: this.per_page,
          status: this.status,
          key: this.keyword
        }
        request({
          url: 'movie-comments',
          method: 'get',
          params: sendData
        }).then(res => {
          resolve()
          this.total = res.data.item_total
          this.comments = res.data.list
          if (this.comments.length === 0) {
            this.noData = true
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    refresh () {
      this.page = 1
      this.getComments().then(res => {})
    },
    currentChange (e) {
      this.page = e
      this.getComments()
    },
    handleSizeChange (e) {
      this.per_page = e
      this.page = 1
      this.getComments()
    },
    changeHandle (value, item) {
      let sendData = {
        type: value === 1 ? 'show' : 'hide'
      }
      request({
        url: 'movie-comments/' + item.uuid,
        method: 'patch',
        params: sendData
      }).then(res => {
      })
    },
    deleteComment (item) {
      this.$confirm('删除该条评论，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        request({
          url: 'movie-comments/' + item.uuid,
          method: 'delete'
        }).then(res => {
          this.currentChange(1)
        })
      }).catch(() => {})
    },
    ShowReplyCommentLayer (item) {
      this.currentReply = item
      this.isShowReplyCommentLayer = true
      this.replyText = ''
      if (item.official_reply) {
        this.replyText = item.official_reply
      }
    },
    replyComment () {
      let sendData = {
        type: 'reply',
        text: this.replyText
      }
      request({
        url: 'movie-comments/' + this.currentReply.uuid,
        method: 'PATCH',
        data: sendData
      }).then(res => {
        this.currentChange(1)
        this.isShowReplyCommentLayer = false
        this.$message.success('回复成功!')
        this.replyText = ''
      })
    },
    changeline (str) {
      return str.replace(/\n/g, '<br/>')
    },
    getDay (date) {
      return getDay(date)
    }
  }
}
</script>
<style lang="less" scoped>
.input, .select {
  width: 150px;
}
.list {
  border-top: 1px solid #E4E7ED;
  .item {
    margin-top: 10px;
    border-bottom: 1px solid #EBEEF5;
    .user {
      display: flex;
      margin-bottom: 10px;
      max-width: 700px;
      position: relative;
      .head-img {
        width: 50px;
        height: 50px;
        margin-right: 10px;
        border-radius: 5px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          margin: 0 auto;
          display: block;
        }
      }
      .text {
        width: 600px;
        font-size: 15px;
        .name {
          margin-bottom: 5px;
          .small {
            font-style: normal;
            font-size: 13px;
          }
        }
        .images {
          margin-top: 10px;
          display: flex;
          flex-wrap: wrap;
          .images-item {
            width: 70px;
            height: 70px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;
            margin-bottom: 10px;
          }
        }
        .tenant-reply {
          margin-top: 5px;
          border-left: 3px solid #67C23A;
          padding: 5px 10px;
          background-color: #F2F6FC;
        }
        .bottom {
          margin-top: 10px;
          font-size: 13px;
        }
        .comment pre {
          width: 100%;
          white-space:pre-wrap;
          word-wrap:break-word;
        }
      }
      .operation {
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        align-items: center;
        .switch {
          transform: scale(0.8,0.8)
        }
        .delete, .reply {
          margin-left: 6px;
          font-size: 16px;
        }
      }
    }
  }
  .empty {
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 150px;
      height: auto;
    }
  }
}
.page {
  margin-top: 10px;
  margin-bottom: 10px;
}
.product-item {
  border: 1px solid #E4E7ED;
  padding: 5px;
  .product-img {
    width: 80px;
    height: 80px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
      height: auto;
    }
  }
  .product-name {
    text-align: center;
    padding: 3px 0;
    font-size: 13px;
    color: #555555;
  }
}
.warning {
  color: #E6A23C;
}
.reply-content {
  width: 700px;
  h3 {
    line-height: 45px;
    text-align: center;
  }
  .btn-group {
    text-align: center;
    margin-top: 10px;
    padding: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/comment/movie.vue